import capitalize from 'lodash/capitalize';
import snakeCase from 'lodash/snakeCase';
import { licenseTypesMap } from "../../LicenseReports/LicenseReportsTableData";
export const licenseDetailsConfig = [{
  head: '',
  content: [{
    label: 'Addon license ID',
    apiKeyPath: 'addonLicenseId'
  }, {
    label: 'Host license',
    apiKeyPath: 'hostLicense'
  }, {
    label: 'License ID',
    apiKeyPath: 'licenseId'
  }, {
    label: 'Addon key',
    apiKeyPath: 'addonKey'
  }, {
    label: 'Addon name',
    apiKeyPath: 'addonName'
  }, {
    label: 'License type',
    // $FlowFixMe We know that this will always be license
    condition: license => {
      const licenseTypeMapValue = licenseTypesMap[snakeCase(license.licenseType)];
      const licenseType = capitalize(license.licenseType);
      return licenseTypeMapValue ? "".concat(licenseTypeMapValue, ", ").concat(licenseType) : licenseType;
    }
  }, {
    label: 'Status',
    apiKeyPath: 'status'
  }, {
    label: 'Hosting',
    apiKeyPath: 'hosting'
  }, {
    label: 'Tier',
    apiKeyPath: 'tier'
  }]
}, {
  head: 'Customer Technical Contact',
  content: [{
    label: 'Technical contact name',
    apiKeyPath: 'contactDetails.technicalContact.name'
  }, {
    label: 'Technical contact email',
    apiKeyPath: 'contactDetails.technicalContact.email'
  }, {
    label: 'Address',
    apiKeyPath: 'contactDetails.technicalContact.address1'
  }, {
    label: 'City',
    apiKeyPath: 'contactDetails.technicalContact.city'
  }, {
    label: 'Phone',
    apiKeyPath: 'contactDetails.technicalContact.phone'
  }, {
    label: 'Postcode',
    apiKeyPath: 'contactDetails.technicalContact.postCode'
  }]
}, {
  head: 'Partner info',
  content: [{
    label: 'Partner name',
    apiKeyPath: 'partnerDetails.partnerName'
  }, {
    label: 'Partner contact name',
    apiKeyPath: 'partnerDetails.billingContact.name'
  }, {
    label: 'Partner contact email',
    apiKeyPath: 'partnerDetails.billingContact.email'
  }, {
    label: 'Partner type',
    apiKeyPath: 'partnerDetails.partnerType'
  }]
}, {
  head: 'Customer info',
  content: [{
    label: 'Company',
    apiKeyPath: 'contactDetails.company'
  }, {
    label: 'Country',
    apiKeyPath: 'contactDetails.country'
  }, {
    label: 'Region',
    apiKeyPath: 'contactDetails.region'
  }]
}, {
  head: 'Maintenance Period',
  content: [{
    label: 'Start date',
    apiKeyPath: 'maintenanceStartDate'
  }, {
    label: 'End date',
    apiKeyPath: 'maintenanceEndDate'
  }]
}, {
  head: 'Customer Billing Contact',
  content: [{
    label: 'Billing contact name',
    apiKeyPath: 'contactDetails.billingContact.name'
  }, {
    label: 'Billing contact email',
    apiKeyPath: 'contactDetails.billingContact.email'
  }, {
    label: 'Address',
    apiKeyPath: 'contactDetails.billingContact.address1'
  }, {
    label: 'City',
    apiKeyPath: 'contactDetails.billingContact.city'
  }, {
    label: 'Phone',
    apiKeyPath: 'contactDetails.billingContact.phone'
  }, {
    label: 'Postcode',
    apiKeyPath: 'contactDetails.billingContact.postCode'
  }]
}];